import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import InlineInput from "src/components/inline-input/InlineInput";
import ThemeSelect from "src/components/theme-select/ThemeSelect";
import { pantsSizes } from "src/config/reviewSystemData";
import sizes from "src/config/sizes";
import { Option } from "src/types/global/Option";

interface ReviewerMeasurementsFormProps {
  height: string;
  setHeight: Dispatch<SetStateAction<string>>;
  weight: string;
  setWeight: Dispatch<SetStateAction<string>>;
  pantSize: Option;
  setPantSize: Dispatch<SetStateAction<Option>>;
  sizePurchased: Option;
  setSizePurchased: Dispatch<SetStateAction<Option>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  isFormSubmittedOnce: boolean;
}

const ReviewerMeasurementsForm = ({
  height,
  setHeight,
  weight,
  setWeight,
  pantSize,
  setPantSize,
  sizePurchased,
  setSizePurchased,
  setReviewStep,
  isFormSubmittedOnce,
}: ReviewerMeasurementsFormProps) => {
  const t = useTranslations("ReviewForm");

  const sizesOptions = sizes.map((size) => ({
    label: size.name.toUpperCase(),
    value: size.name,
  }));

  return (
    <>
      <section className="m-auto flex flex-col items-center gap-10">
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-center text-2xl font-semibold">
            {t("and_more_about_you")}
          </h2>
          <p className="text-sm text-gray-600">
            {t("*_indicates_required_fields")}
          </p>
        </div>
        <div className="flex w-full flex-col items-center gap-4">
          <div className="adjacent-items w-full">
            <InlineInput
              label={t("height_cm")}
              value={height}
              type="number"
              onChange={(event) => setHeight(event.target.value)}
            />
            <InlineInput
              label={t("weight_kg")}
              value={weight}
              type="number"
              onChange={(event) => setWeight(event.target.value)}
            />
          </div>
          <div className="adjacent-items w-full">
            <ThemeSelect
              containerClasses="w-full"
              listOptionsClasses="text-start items-start z-50"
              options={pantsSizes}
              value={pantSize}
              onChange={(option) => setPantSize(option)}
            />
            <ThemeSelect
              containerClasses="w-full"
              listOptionsClasses="text-start items-start z-50"
              options={sizesOptions}
              value={sizePurchased}
              onChange={(option) => setSizePurchased(option)}
            />
          </div>
        </div>
      </section>
      <div className="flex self-end">
        {isFormSubmittedOnce ? (
          <ThemeButton
            onClick={() => setReviewStep(9)}
            disabled={sizePurchased.value === "" || !sizePurchased}
          >
            {t("preview_your_review")}
          </ThemeButton>
        ) : (
          <ThemeButton
            onClick={() => setReviewStep((prevstep) => prevstep + 1)}
            disabled={sizePurchased.value === "" || !sizePurchased}
          >
            {t("next")}
          </ThemeButton>
        )}
      </div>
    </>
  );
};

export default ReviewerMeasurementsForm;
